import {AfterContentInit, Component, ViewChild} from '@angular/core';
import {ApDynComponentComponent}                from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerConfigBase
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {
  ApDynGridStatusColumnConfig
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPropertyColumnConfig
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  ApDynGridEditColumnConfig
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {WorkTypesStore}                         from '../../stores/base-data/worrktypes.store';
import {filter, map}                            from 'rxjs/operators';
import {IGridData}                              from '../../ap-interface/interfaces';
import {FarmUsersStore}                         from '../../stores/farm/farm.users.store';
import {MapViewStore}                           from '../../stores/layout/mapview.store';
import {TranslationStore}                       from '../../stores/translation/translation.store';
import IWorkTypes = Data.BaseData.IWorktypes;

/**
 * TODO Worktypes Shortname und Description Übersetzung --> Jira Ticket angelegt https://jira.agricon.de/browse/APV49-819
 */

interface IWorkTypesGridData extends IGridData<IWorkTypes> {
  Status: number;
  StatusClass: string;
  StatusDesc: string;
  Type: string;
  Description: string;
  ShortName: string;
  Unit: string;
}

/**
 * Component for the worktypes
 */
@Component({
  selector: 'ap-worktypes-overview',
  template: `
    <ap-dyncomponent [caption]="'Docu_Ini__WorkTypes'"
                     [canSearch]="true"
                     [headerIcon]="'ap-basedata-icon'"
                     [filterTooltip]="'filterTooltip'"
                     [columns]="columns"
                     [items]="this.items$ | async"
                     [loading$]="workTypeLoading$"
                     [pager]="pager"
                     [groupable]="true"
                     [selectable]="{checkboxOnly: false, mode: 'multiple'}"
    ></ap-dyncomponent>`
})

export class ApWorktypesOverviewComponent implements AfterContentInit {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  columns: ApDynGridColumnConfigBase[] = [];
  pager: ApDynGridPagerConfigBase;
  workTypeLoading$ = this.store.Listen(s => s.loading);
  public items$ = this.store.Listen(s => s.data).pipe(
    filter(d => !!d),
    map(d => d.Convert<IWorkTypesGridData>(workType => {
      const type = this.translationStore.FindTranslationForSelectedLanguage(workType.Category_Text);
      const description = this.translationStore.FindTranslationForSelectedLanguage(workType.Description);
      const shortName = this.translationStore.FindTranslationForSelectedLanguage(workType.Shortname);
      const unit = this.translationStore.FindTranslationForSelectedLanguage(workType.Wt_Unit);
      return {
        Id: workType.Id,
        SourceItem: workType,
        Status: 1,
        StatusClass: 'ap-status-green',
        StatusDesc: 'Global__Active',
        Type: type,
        Description: description,
        ShortName: shortName,
        Unit: unit
      };
    })));

  constructor(private store: WorkTypesStore,
              private farmUsersStore: FarmUsersStore,
              private translationStore: TranslationStore,
              private mapViewStore: MapViewStore) {
    this.mapViewStore.hideMapView();
  }

  ngAfterContentInit(): void {
    this.gridBuilder();
  }

  private gridBuilder(): void {
    this.columns = [
      new ApDynGridStatusColumnConfig({
        field: 'Status',
        showHeaderTitle: true,
        class: 'StatusClass',
        description: 'StatusDesc',
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Type',
        title: 'Docu_Ini__Type',
        filterable: true,
        width: 150,
        headerFilterable: true,
        groupIndex: 0,
        groupDesc: false
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Description',
        title: 'Global__Description',
        filterable: true,
        width: 100,
        headerFilterable: true,
        sortIndex: 0,
        sortDesc: false,
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Unit',
        title: 'Settings__Lbl_Menu_Unit',
        filterable: true,
        width: 70,
        headerFilterable: true
      })
    ];
    this.pager = new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardSection()
    );
  }
}
